$bog_vmap_app_code $mol_page
	klass \
	prop \
	hooks /string
	source? \
	node_source? \
	js? \
	css? \
	error \
	node_note \
	whole? false
	refusal? \
	field_undo false
	editable true
	event *
		^
		focusout? <=> field_leave? null
	title <= scope_note \
	tools /
		<= Scope $mol_check
			title \Весь класс
			hint \Править класс целиком, а не выбранный узел. Какой это класс, сказано в шапке: у узла со своим классом — его, у остальных — тот, который узел объявляет
			checked? <=> whole?
	Alarm $mol_status
		status <= error
	Refusal $mol_status
		status <= note \
	Typing $mol_list
		rows <= typing_rows /$mol_view
	Typing_row* $mol_status
		status <= typing_text* \
	Sources $bog_vmap_app_code_deck
		items <= source_tabs /$mol_view
	Tree $mol_textarea
		title \view.tree
		hint \Имя_узла $mol_view
		sidebar_showed true
		enabled <= editable
		value? <=> tree_text? \
		event *
			^
			pointerdown? <=> tree_press? null
	Js $mol_textarea
		title \JS
		hint \
		sidebar_showed true
		enabled <= editable
		value? <=> js_text? \
		event *
			^
			pointerdown? <=> js_press? null
	Js_idle $mol_status
		title \JS
		status <= js_idle_note \
	Css $mol_textarea
		title \CSS
		hint \
		sidebar_showed true
		enabled <= editable
		value? <=> css_text? \
		event *
			^
			pointerdown? <=> css_press? null

$bog_vmap_app_code_deck $mol_deck
